import { withNamespace } from '../helper';

const namespace = '@BUSINESS';

export const GET_ACTIVE_BUSINESSES = withNamespace('GET_ACTIVE_BUSINESSES', namespace);
export const GET_ACTIVE_BUSINESSES_SUCCESS = withNamespace(
  'GET_ACTIVE_BUSINESSES_SUCCESS',
  namespace,
);
export const SET_BUSINESS = withNamespace('SET_BUSINESS', namespace);
